import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=31561f89"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31561f89')) {
      api.createRecord('31561f89', component.options)
    } else {
      api.reload('31561f89', component.options)
    }
    module.hot.accept("./Camera.vue?vue&type=template&id=31561f89", function () {
      api.rerender('31561f89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Camera.vue"
export default component.exports